import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import {
    khoaGetItemAction,
    editKhoaAction
} from '../../store/reducers/khoa';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    maKhoa: yup.string().required(messageError.emptyMessage),
    name: yup.string().required(messageError.emptyMessage)
});

const DMKhoaEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const khoaItem = useSelector((state) => state.khoa.khoaItem);

    const [isLoading, setIsLoading] = useState(false);
    const [idKhoa, setIdKhoa] = useState('');

    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        if (paramUrl.get('id')) {
            const id = paramUrl.get('id');
            setIdKhoa(id);
            dispatch(khoaGetItemAction(id));
        }
    }, []);

    const handleEdit = async (values) => {
        const model = values;

        const modelUpdate = {
            data: model,
            id: idKhoa
        };

        try {
            const result = await dispatch(editKhoaAction(modelUpdate));
            if (result.payload !== 200) {
                toast.error(messageToast.messageToastUpdateError);
            } else {
                setIsLoading(true);
                toast.success(messageToast.messageToastUpdateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Sửa thông tin khoa</Card.Header>
            <Card.Body>
                {khoaItem == null ? (
                    <div>Khoa không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            maKhoa: khoaItem?.maKhoa || '',
                            name: khoaItem?.name || ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>

                                {/* Mã khoa */}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mã khoa *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Mã khoa"
                                            type="text"
                                            name="maKhoa"
                                            value={values.maKhoa}
                                            onChange={handleChange}
                                            isInvalid={!!errors.maKhoa}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.maKhoa}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                {/* Tên khoa */}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên khoa *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên khoa"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                {/* Buttons */}
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup>
                                            <Button type="submit" theme="primary">
                                                Sửa
                                            </Button>

                                            &nbsp;&nbsp;&nbsp;

                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>

                            </Form>
                        )}
                    </Formik>
                )}

                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default DMKhoaEdit;
